import { render, staticRenderFns } from "./anti-corruption.vue?vue&type=template&id=240cdea3&scoped=true&"
import script from "./anti-corruption.vue?vue&type=script&lang=js&"
export * from "./anti-corruption.vue?vue&type=script&lang=js&"
import style0 from "./anti-corruption.vue?vue&type=style&index=0&id=240cdea3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240cdea3",
  null
  
)

export default component.exports